import { useState, useEffect } from "react";
import {
  Row,
  Col,
  Steps,
  Button,
  Input,
  Alert,
  Select,
  Form,
  Space,
  Tooltip,
  message,
  Typography,
} from "antd";
import {
  AUTH_TOKEN,
  DOMAIN_ID,
  ORG_ID,
  REACT_APP_API,
  REACT_APP_API_PAM_URL,
  REACT_APP_API_TENANTS_URL,
} from "../../../constants";
import { DownloadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logOutUser } from "../../../common";
import JSZip from "jszip";
import ReactJoyride from "react-joyride";

const { Step } = Steps;
const { Option } = Select;
const ADStep = () => {
  const [current, setCurrent] = useState(0);
  const [orgUrl, setOrgUrl] = useState();
  const [formVal, setFormVal] = useState(null);
  const [selectPairs, setSelectPairs] = useState([{ select1: "Email", select2: "Username" }]);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = message.useMessage();
  const [adId, setAdId] = useState("");
  const [policyList, setPolicyList] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [sslConfigured, setSslConfigured] = useState("");
  const [formData, setFormData] = useState();
  const [adMfaMethod, setAdMfaMethod] = useState(null);
  const [adUsersList, setAdUsersList] = useState([]);

  const [run, setRun] = useState(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const adType = queryParams.get("type");

  const [isADRunning, setIsADRunning] = useState(false);

  useEffect(() => {
    if (adType === "agentBased") {
      setAdMfaMethod(0);
      setFormData([
        {
          name: "adMfa",
          value: 0,
        },
      ]);
    } else if (adType === "agentless") {
      setAdMfaMethod(1);
      setFormData([
        {
          name: "adMfa",
          value: 1,
        },
      ]);
    }
  }, []);

  const tourStatus = JSON.parse(localStorage?.getItem("tourStatus"));
  const isSetupADTour = tourStatus?.setupAD || false;

  const handleUpdateSetupStatus = async () => {
    const payload = {
      orgId: ORG_ID(),
      tenantId: DOMAIN_ID(),
      setupId: 2,
      status: "true",
      overallStatus: "",
    };
    try {
      await axios.post(`${REACT_APP_API_TENANTS_URL}/setTenantSetup`, payload, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const startTour = () => {
    const tourStep = [
      {
        target: "#addIdentityProviderForm",
        content: "Configure an existing domain server by providing your domain details.",
        disableBeacon: true,
        hideCloseButton: true,
        hideFooter: false,
        locale: {
          last: "Next",
        },
      },
      {
        target: "#credentialRotation",
        content:
          "Select the credential rotation policy to force periodic credential updates to minimize breach risks and maintain compliance.",
        disableBeacon: true,
        hideCloseButton: true,
        hideFooter: false,
        locale: {
          last: "Next",
        },
      },

      {
        target: "#adMFAMethod",
        content: "Select the AD MFA method.",
        disableBeacon: true,
        hideCloseButton: true,
        hideFooter: false,
        locale: {
          last: "Next",
        },
      },
      {
        target: "#nextBtn",
        content: "Click Next to save the details and start to Install AD Agent.",
        disableBeacon: true,
        hideCloseButton: true,
        hideFooter: false,
        locale: {
          last: "Got it",
        },
      },
    ];

    const handleTourCallback = ({ status }) => {
      if (status === "finished" || status === "skipped") {
        setRun(false);
        //handleUpdateSetupStatus();
      }
    };

    return (
      <ReactJoyride
        steps={tourStep}
        run={run}
        floaterProps={{ disableAnimation: true }}
        callback={handleTourCallback}
        continuous
        scrollToFirstStep
        disableScrollParentFix
        // scrollOffset={100}
        disableBeacon={true}
        disableOverlayClose={true}
        spotlightClicks={true}
        showSkipButton
        showProgress
        styles={{
          buttonNext: {
            backgroundColor: "#1677ff",
            color: "#ffffff",
          },
          buttonBack: {
            color: "#1677ff",
          },
        }}
      />
    );
  };

  const { Text } = Typography;

  useEffect(() => {
    fetchCredentialRotationPolicy();
  }, []);

  useEffect(() => {
    if (adId) {
      fetchAdUsers();
    }
  }, [adId]);

  const fetchAdUsers = async () => {
    let payload = {
      orgId: ORG_ID(),
      tenantId: DOMAIN_ID(),
      pageNo: 1,
      pageSize: 100,
      filters: {
        emailId: "",
        status: "",
        logoname: "",
        adId: adId && adId,
      },
    };

    try {
      const res = await axios.post(`${REACT_APP_API}/ad/GetAllAdUsers`, payload, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      });

      const tempData = res?.data?.users.map((user) => ({
        id: user?.id,
        label: user?.username,
        value: user?.id,
      }));

      setAdUsersList(tempData);
    } catch (error) {
      console.log(error);
    }
  };

  const createADMFAZipAndDownload = async () => {
    const zip = new JSZip();
    const url =
      "https://raw.githubusercontent.com/authnull0/windows-endpoint/refs/heads/main/agentless-install.ps1";

    // Add text content as a separate file to the ZIP
    zip.file("authnull-MFA.conf", textContent);

    // Fetch the file from the provided URL
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");

      const fileBlob = await response.blob();

      // Add the downloaded file to the ZIP
      zip.file("agentless-install.ps1", fileBlob);

      // Generate the ZIP file
      const zipBlob = await zip.generateAsync({ type: "blob" });

      // Create a download link for the ZIP file
      const link = document.createElement("a");
      link.href = URL.createObjectURL(zipBlob);
      link.download = "agentless-install.zip";
      link.click();

      // Clean up the URL object
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };

  const createZipAndDownload = async () => {
    const zip = new JSZip();
    const url =
      "https://raw.githubusercontent.com/authnull0/windows-endpoint/refs/heads/main/ad-agent-install.ps1";
    // Add text content as a separate file to the ZIP
    zip.file("agent.conf", textContent);

    // Fetch the file from the provided URL
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");

      const fileBlob = await response.blob();

      // Add the downloaded file to the ZIP
      zip.file("ad-agent-install.ps1", fileBlob);

      // Generate the ZIP file
      const zipBlob = await zip.generateAsync({ type: "blob" });

      // Create a download link for the ZIP file
      const link = document.createElement("a");
      link.href = URL.createObjectURL(zipBlob);
      link.download = "AD-agent-install.zip";
      link.click();

      // Clean up the URL object
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };

  const handleConnectADSubmit = (e) => {
    console.log(e);
    // const Domain = e?.dc?.split(",");
    const Domain = e?.domain;
    const dc1 = Domain.split(".")[0];
    const dc2 = Domain.split(".")[1];
    const payload = {
      ...e,
      dc1: dc1,
      dc2: dc2,
      orgId: ORG_ID(),
      tenantId: DOMAIN_ID(),
      status: "Pending",
      adAdminUserName: e?.userName,
    };
    setFormVal(payload);

    setIsLoading(true);
    axios
      .post(`${REACT_APP_API}/ad/AddDomain`, payload, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.status === 400) {
          notification.open({
            type: "error",
            content: "Domain already exists",
          });
        } else {
          setAdId(res.data.id);
          setCurrent(current + 1);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if (
          err?.response?.data?.message === "Invalid credentials" ||
          err?.response?.status === 401
        ) {
          logOutUser();
        } else {
          notification.open({
            type: "error",
            content: "Active Directory already exists.",
          });
        }
      });
  };

  const fetchCredentialRotationPolicy = () => {
    let policyPayload = {
      pageId: 1,
      pageSize: 100,
      search: "",
      credentialType: "PASSWORD",
      filter: {
        filterBy: "userType",
        value: "LDAP",
      },
      domainId: DOMAIN_ID(),
      orgId: ORG_ID(),
    };
    axios
      .post(`${REACT_APP_API_PAM_URL}/instances/listAllCredentialRotationPolicy`, policyPayload, {
        headers: {
          "X-Authorization": AUTH_TOKEN(),
          withCredentials: true,
        },
      })
      .then((res) => {
        setIsLoading(false);
        const newPolicyData = res?.data?.credentialPolicies?.map((data, index) => ({
          id: index + 1,
          label: data?.policyName,
          value: data?.policyId,
        }));
        setPolicyList(newPolicyData);
        const filteredValue = res?.data?.credentialPolicies?.filter(
          (data) => data?.policyName === "No Password Policy"
        );
        form.setFieldsValue({ credentialRotationPolicyId: filteredValue[0].policyId });
      })
      .catch((err) => {
        setIsLoading(false);
        if (
          err?.response?.data?.message === "Invalid credentials" ||
          err?.response?.status === 401
        ) {
          notification.open({
            type: "error",
            content: "Credentials are invalid",
          });

          logOutUser();
        }
        console.log(err.message);
      });
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };
  const textContent = `LDAP_SSL_PORT=${formVal?.SSLconfigured === "No" ? 0 : formVal?.Port}
LDAP_SERVER=${formVal?.adHost}
LDAP_PORT=389
LDAP_USERNAME=${formVal?.userName}
BASE_DN=${formVal?.dc}
DOMAIN=${formVal?.domain}
MachineName=${formVal?.directoryName}
#   time interval is 10 minutes
CRON_SCHEDULE= */10 * * * *
DomainId=${adId}
TenantId=${localStorage.getItem("DomainId")}
OrgId=${localStorage.getItem("OrgId")}
BaseURL=${REACT_APP_API}
SERVICEACCOUNT_BASE_DN=${formVal?.serviceAccountDomain}
ADMFA=${adMfaMethod}
MFACatchingTime=60`;

  const downloadPamCode = () => {
    let fileName = "agent.conf";
    let fileContent = textContent;
    let element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(fileContent)
    );
    element.setAttribute("download", fileName);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const FirstContent = () => {
    const [selectedUsers, setSelectedUsers] = useState([]);

    useEffect(() => {
      fetchADMachine();
    }, []);

    const updateAdUsers = async () => {
      const payload = {
        tenantId: DOMAIN_ID(),
        orgId: ORG_ID(),
        adId: adId,
        userId: selectedUsers,
        mfaFlag: adMfaMethod,
      };

      try {
        const res = await axios.post(`${REACT_APP_API}/ad/UpdateMfaFlagADUsers`, payload, {
          headers: {
            withCredentials: true,
            "X-Authorization": AUTH_TOKEN(),
          },
        });

        // navigate("/directory/activeDirectory");
        message.success("Users added successfully");
      } catch (error) {
        message.error("Failed to add users");
        console.log(error);
      }
    };

    const fetchADMachine = () => {
      let pageDetails = {
        tenantId: DOMAIN_ID(),
        filter: "",
        orgId: ORG_ID(),
      };
      axios
        .post(`${REACT_APP_API}/ad/GetAllDomains`, pageDetails, {
          headers: {
            "X-Authorization": AUTH_TOKEN(),
            withCredentials: true,
          },
        })
        .then((res) => {
          const adMachine = res?.data?.domains?.filter((ad) => ad.id === adId);

          if (adId && adMachine.length > 0) {
            setIsADRunning(true);
          }
        })
        .catch((err) => {
          if (
            err?.response?.data?.message === "Invalid credentials" ||
            err?.response?.status === 401
          ) {
            logOutUser();
          } else {
            notification.open({
              type: "error",
              content: "Unable to verify AD machine",
            });
          }
        });
    };

    return (
      <Row>
        <Col span={24}>
          <Row style={{ marginTop: "2rem" }}>
            <h3
              style={{
                fontSize: "18px",

                marginBottom: "1rem",
                fontWeight: 500,
              }}
            >
              Install Active Directory Agent
            </h3>
          </Row>
          <Row>
            <p>
              <b>Step 1: </b> Download the installation file and copy it to a machine where you want
              to install.
            </p>
          </Row>
          <Row>
            <Col span={12}>
              <Button type="primary" onClick={createZipAndDownload}>
                Download <DownloadOutlined />
              </Button>
            </Col>
          </Row>

          <Row style={{ marginTop: "1rem" }}>
            <Col span={20}>
              <p>
                <b>Step 2 : </b> Open the PowerShell window as an administrator privilege and
                execute the following command to change the execution policy.
              </p>
            </Col>
            <Col span={20}>
              <Input
                style={{ border: "none", padding: "1rem" }}
                size="large"
                value="Set-ExecutionPolicy Unrestricted -Scope CurrentUser"
                disabled
                suffix={
                  <Text
                    style={{ color: "GrayText" }}
                    copyable={{
                      text: "Set-ExecutionPolicy Unrestricted -Scope CurrentUser",
                      tooltips: ["Copy Command", "Copied"],
                    }}
                  ></Text>
                }
              />
            </Col>
          </Row>

          <Row style={{ marginTop: "1rem" }}>
            <Col span={20}>
              <Row>
                <p>
                  <b>Step 3 : </b> Go to the directory where you downloaded the installation file
                  and execute the following command in the PowerShell window.
                </p>
                <Input
                  style={{ border: "none", padding: "1rem" }}
                  size="large"
                  value=".\ad-agent-install.ps1 -OutputPath C:\authnull-ad-agent"
                  disabled
                  suffix={
                    <Text
                      style={{ color: "GrayText" }}
                      copyable={{
                        text: ".\\ad-agent-install.ps1 -OutputPath C:\\authnull-ad-agent",
                        tooltips: ["Copy Command", "Copied"],
                      }}
                    ></Text>
                  }
                />
              </Row>
            </Col>
          </Row>

          <Row style={{ marginTop: "1rem" }}>
            <Col span={20}>
              <p>
                <b>Step 4 : </b> After successfully installation of the AD agent, Navigate to{" "}
                <Link to="/pam/users" target="_blank" style={{ color: "#1677ff" }}>
                  Identities {">"} Users
                </Link>{" "}
                screen to view all the imported active directory users successfully.
              </p>
            </Col>

            <Col span={20}>
              <p>
                <b>Step 5 : </b> To check the status of the Agent, navigate to
                <b> Start {">"} Services </b>, there you should see the service{" "}
                <b>AuthNullADAgent</b> with status running.
              </p>
            </Col>

            <Col span={20}>
              <p>
                <b>Step 6 : </b> To check the logs, nagivate to the "authnull-ad-agent" directory
                inside your C drive.
              </p>

              <Input
                style={{ border: "none", padding: "1rem" }}
                size="large"
                value="C:\authnull-ad-agent"
                disabled
                suffix={
                  <Text
                    style={{ color: "GrayText" }}
                    copyable={{
                      text: "C:\\authnull-ad-agent",
                      tooltips: ["Copy Command", "Copied"],
                    }}
                  ></Text>
                }
              />
            </Col>
          </Row>

          {adMfaMethod === 1 && (
            <>
              <Row style={{ marginTop: "1rem" }}>
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: 500,
                  }}
                >
                  Configure Agentless MFA
                </h3>
              </Row>

              <Row>
                <Col>
                  <p>Prerequisite:</p>
                  <ul>
                    <li>AD Agent Installed: Required for syncing AD Users and Service Accounts.</li>
                    <li>Domain-Joined Machines - All Windows endpoints must be domain-joined.</li>
                  </ul>
                </Col>
              </Row>

              <Row>
                <p>
                  <b>Step 1: </b> Download the Agentless MFA setup script and copy it to the active
                  directory machine.
                </p>
              </Row>
              <Row>
                <Col span={12}>
                  <Button type="primary" onClick={createADMFAZipAndDownload}>
                    Download <DownloadOutlined />
                  </Button>
                </Col>
              </Row>
              <Row style={{ marginBottom: "1rem" }}>
                <Col span={20}>
                  <Row>
                    <p>
                      <b>Step 2: </b> In the active directory machine, open the PowerShell window as
                      an administrator privilege and execute the following command.
                    </p>
                    <Input
                      style={{ border: "none", padding: "1rem" }}
                      size="large"
                      value=".\agentless-install.ps1"
                      disabled
                      suffix={
                        <Text
                          style={{ color: "GrayText" }}
                          copyable={{
                            text: ".\\agentless-install.ps1",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                        ></Text>
                      }
                    />

                    <p>
                      After running the commands, the script confirms the config file was read,
                      downloads SubAuth.dll to System32, sets the registry key 'Authd' to 'SubAuth',
                      and forces a system restart in 10 seconds to apply changes.
                    </p>

                    <p>
                      <b>Step 3:</b> Open "Registry Editor" and navigate to:
                      "HKEY_LOCAL_MACHINE\SYSTEM\CurrentControlSet\Control\Lsa\MSV1_0" to verify the
                      newly added registry key.
                    </p>

                    <p>
                      <b>Step 4:</b> Navigate to the System32 directory to verify the downloaded
                      SubAuth.dll file is present.
                    </p>

                    <p>
                      You can click on the "Finish" to close this screen or "Onboard Endpoint"
                      button to onboard windows endpoint, to learn more visit the{" "}
                      <Link
                        to="https://help.authnull.com/docs/active-directory/"
                        target="_blank"
                        style={{ color: "#1677ff" }}
                      >
                        AuthNull Help Docs.
                      </Link>
                    </p>
                  </Row>
                </Col>
              </Row>
            </>
          )}

          <Row style={{ marginTop: "1rem", marginBottom: "2rem" }} justify="space-between">
            <Col>
              <Button
                type="default"
                style={{ marginRight: "1rem" }}
                onClick={() => {
                  prev();
                }}
              >
                Prev
              </Button>
              <Button
                onClick={() => {
                  updateAdUsers();
                  navigate("/pam/endpoint/addEndpoint/windows?MFA=ldap&adId=" + adId);
                }}
                type="primary"
                style={{ marginRight: "1rem" }}
                disabled={!isADRunning}
              >
                Onboard Endpoint
              </Button>
              <Button
                onClick={() => {
                  updateAdUsers();
                  navigate("/directory/activeDirectory");
                }}
                type="primary"
                style={{ fontSize: "16px" }}
              >
                Finish
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const SecondContent = () => {
    return (
      <Row>
        <Col span={20}>
          <Row>
            <h2 style={{ fontSize: "18px", marginTop: "1rem", fontWeight: 500 }}>
              Configure to AD server
            </h2>
          </Row>
          <Row>
            <Col span={24} id="addIdentityProviderForm">
              <Form
                form={form}
                layout="vertical"
                onFinish={handleConnectADSubmit}
                fields={formData}
                initialValues={{
                  SSLconfigured: "Yes",
                  Port: 636,
                }}
                onValuesChange={(changedValues) => {
                  if (changedValues.SSLconfigured !== undefined) {
                    form.setFieldsValue({
                      Port: changedValues.SSLconfigured === "Yes" ? 636 : 0,
                    });
                    setSslConfigured(changedValues);
                  }
                }}
              >
                <div>
                  <Row justify="space-between" align="middle">
                    <Col span={11}>
                      <Form.Item
                        name="directoryName"
                        label="Active Directory Name"
                        rules={[
                          {
                            required: true,
                            message: "AD Name is required",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={11}>
                      <Form.Item
                        name="dc"
                        label={
                          <span>
                            Search Base for User&nbsp;
                            <Tooltip
                              title={
                                <span>
                                  Search Base for User must be ou=user,dc=example,dc=com format
                                </span>
                              }
                            >
                              <InfoCircleOutlined />
                            </Tooltip>
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Search Base for User is required",
                          },
                          {
                            pattern:
                              /^((cn=[a-zA-Z0-9]+,|ou=[a-zA-Z0-9]+,)+dc=[a-zA-Z0-9]+,dc=[a-zA-Z0-9]+)$/,
                            message:
                              "Search Base for User must be ou=user,dc=example,dc=com format",
                          },
                        ]}
                      >
                        <Input placeholder="eg:ou=user,dc=example,dc=com" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="space-between" align="middle">
                    <Col span={11}>
                      <Form.Item
                        name="serviceAccountDomain"
                        label={
                          <span>
                            Search Base for Service Account&nbsp;
                            <Tooltip
                              title={
                                <span>
                                  Search Base for Service Account must be
                                  ou=serviceaccount,dc=example,dc=com format
                                </span>
                              }
                            >
                              <InfoCircleOutlined />
                            </Tooltip>
                          </span>
                        }
                        rules={[
                          {
                            pattern: /^(ou=[a-zA-Z0-9]+,dc=[a-zA-Z0-9]+,dc=[a-zA-Z0-9]+)$/,
                            message:
                              "Search Base for Service Account must be ou=serviceaccount,dc=example,dc=com format",
                          },
                        ]}
                      >
                        <Input placeholder="eg:ou=serviceaccount,dc=example,dc=com" />
                      </Form.Item>
                    </Col>
                    <Col span={11}>
                      <Form.Item
                        name="domain"
                        label={
                          <span>
                            Domain&nbsp;
                            <Tooltip title={<span>Domain must be "domain.com" format</span>}>
                              <InfoCircleOutlined />
                            </Tooltip>
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Domain is required",
                          },
                          {
                            pattern: /^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
                            message: `Domain must be ${"domain.com"} format`,
                          },
                        ]}
                      >
                        <Input placeholder="eg:domain.com" />
                      </Form.Item>
                    </Col>

                    <Col span={11}>
                      <Form.Item
                        name="adHost"
                        label="AD IP Address"
                        rules={[
                          {
                            required: true,
                            message: "AD IP is required",
                          },
                          {
                            pattern: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
                            message: "IP address range must be 0.0.0.0 to 255.255.255.255",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={11}>
                      <Form.Item
                        name="userName"
                        label={
                          <span>
                            Username&nbsp;
                            <Tooltip title={<span>Admin Username</span>}>
                              <InfoCircleOutlined />
                            </Tooltip>
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Username is required",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    {/* <Col span={11}>
                      <Form.Item
                        name="password"
                        label={
                          <span>
                            Password&nbsp;
                            <Tooltip title={<span>Admin password is not stored anywhere </span>}>
                              <InfoCircleOutlined />
                            </Tooltip>
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                        ]}
                      >
                        <Input.Password />
                      </Form.Item>
                    </Col> */}

                    <Col span={11} id="credentialRotation">
                      <Form.Item
                        name="credentialRotationPolicyId"
                        label="Credential Rotation Policy"
                        rules={[
                          {
                            required: true,
                            message: "Select a credential rotation policy",
                          },
                        ]}
                        value={formData?.credentialRotationPolicyId}
                      >
                        <Select tokenSeparators={[","]} options={policyList} />
                      </Form.Item>
                    </Col>
                    <Col span={11}>
                      <Form.Item
                        label="SSL Configured"
                        name="SSLconfigured"
                        rules={[
                          {
                            required: true,
                            message: "Please select yes or no!",
                          },
                        ]}
                      >
                        <Select>
                          <Option value="Yes">Yes</Option>
                          <Option value="No">No</Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col span={11} id="adMFAMethod">
                      <Form.Item
                        name="adMfa"
                        label={
                          <span>
                            Select AD MFA Method&nbsp;
                            <Tooltip
                              title={
                                <span>
                                  Agentless = no software, cloud-friendly. Agent-Based = installed
                                  agents, on-prem control. Pick based on security & deployment
                                  needs.{" "}
                                  <Link to="https://help.authnull.com/docs/active-directory/">
                                    learn more
                                  </Link>
                                </span>
                              }
                            >
                              <InfoCircleOutlined />
                            </Tooltip>
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Select AD MFA method",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select AD MFA method"
                          onChange={(value) => setAdMfaMethod(value)}
                        >
                          <Option value={1}>Agentless AD MFA</Option>
                          <Option value={0}>Agent based AD MFA</Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    {form.getFieldValue("SSLconfigured") === "Yes" && (
                      <Col span={11}>
                        <Form.Item
                          name="Port"
                          label="Port"
                          rules={[
                            {
                              required: true,
                              message: "Port is required",
                            },
                          ]}
                        >
                          <Input placeholder="Enter port number" type="number" allowClear />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                </div>
                <Row style={{ marginTop: "1rem" }} justify="space-between">
                  <Col></Col>
                  <Col>
                    <Button
                      style={{ marginRight: "1rem" }}
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button id="nextBtn" type="primary" htmlType="submit" loading={isLoading}>
                      Next
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };
  //   return (
  //     <Row>
  //       {/* Your content for the second step */}
  //       <Col span={20}>
  //         <Row style={{ marginTop: "2rem" }}>
  //           <h3>Import Users</h3>
  //         </Row>
  //         <Row>
  //           <Col span={24}>
  //             <Row gutter={32}>
  //               <Col span={12}>
  //                 <Row>
  //                   <p className="search-label">Select Organizational Unit</p>
  //                 </Row>
  //                 <Row>
  //                   <Select style={{ width: "100%" }} showSearch placeholder="" labelInValue={true}>
  //                     <Option value="0">kloudone</Option>
  //                     <Option value="1">authnull</Option>
  //                     <Option value="2">Authnull</Option>
  //                   </Select>
  //                 </Row>
  //               </Col>
  //               <Col span={12}>
  //                 <Row>
  //                   <p className="search-label">DID Username Format (skip this if not necessary)</p>
  //                 </Row>
  //                 <Row>
  //                   <Select style={{ width: "100%" }} showSearch placeholder="" labelInValue={true}>
  //                     <Option value="0">Email Address</Option>
  //                     <Option value="1">SAM Account Name</Option>
  //                     <Option value="2">User Principal Name (UPN)</Option>
  //                   </Select>
  //                 </Row>
  //               </Col>
  //             </Row>
  //           </Col>
  //         </Row>
  //         <Row style={{ marginTop: "1rem" }} justify="space-between">
  //           <Col></Col>
  //           <Col>
  //             <Button
  //               style={{ marginRight: "1rem" }}
  //               onClick={() => {
  //                 prev();
  //               }}
  //             >
  //               Prev
  //             </Button>
  //             <Button type="primary" onClick={() => next()}>
  //               Next
  //             </Button>
  //           </Col>
  //         </Row>
  //       </Col>
  //     </Row>
  //   );
  // };
  // const LastContent = () => {
  //   return (
  //     <Row>
  //       <Col span={20}>
  //         <Row style={{ marginTop: "2rem" }}>
  //           <h3>Map Fields: These fields are mapped from AD to Authnull</h3>
  //         </Row>
  //         <Row>
  //           <Col span={24}>
  //             {selectPairs.map((pair, index) => (
  //               <Row gutter={16} key={index} style={{ marginBottom: "8px" }}>
  //                 <Col span={11}>
  //                   <Select
  //                     value={pair.select1}
  //                     style={{ width: "100%" }}
  //                     onChange={(value) => handleSelect1Change(value, index)}
  //                   >
  //                     {options.map((option) => (
  //                       <Option key={option} value={option}>
  //                         {option}
  //                       </Option>
  //                     ))}
  //                   </Select>
  //                 </Col>
  //                 <Col span={11}>
  //                   <Select
  //                     value={pair.select2}
  //                     style={{ width: "100%" }}
  //                     onChange={(value) => handleSelect2Change(value, index)}
  //                   >
  //                     {options.map((option) => (
  //                       <Option key={option} value={option}>
  //                         {option}
  //                       </Option>
  //                     ))}
  //                   </Select>
  //                 </Col>
  //                 <Col span={2} style={{ textAlign: "center" }}>
  //                   {index > 0 && ( // Ensure there is at least one dropdown pair before showing delete icon
  //                     <DeleteOutlined
  //                       onClick={() => handleRemovePair(index)}
  //                       style={{
  //                         fontSize: "20px",
  //                         cursor: "pointer",
  //                         marginTop: "5px",
  //                       }}
  //                     />
  //                   )}
  //                 </Col>
  //               </Row>
  //             ))}
  //             <Row gutter={16} style={{ justifyContent: "space-between" }}>
  //               <Col span={6}>
  //                 <Button type="dashed" onClick={handleAddPair}>
  //                   Add More +
  //                 </Button>
  //               </Col>
  //               <Col span={6}>
  //                 <Button type="default" style={{ marginLeft: "1rem" }}>
  //                   Reconfigure
  //                 </Button>
  //               </Col>
  //             </Row>
  //             <Row style={{ marginTop: "1rem" }} justify="space-between">
  //               <Col></Col>
  //               <Col>
  //                 <Button
  //                   style={{ marginRight: "1rem" }}
  //                   onClick={() => {
  //                     prev();
  //                   }}
  //                 >
  //                   Prev
  //                 </Button>
  //                 <Button type="primary" onClick={() => next()}>
  //                   Next
  //                 </Button>
  //               </Col>
  //             </Row>
  //           </Col>
  //         </Row>
  //       </Col>
  //     </Row>
  //   );
  // };

  const steps = [
    {
      title: "Configure to AD servers",
      content: <SecondContent />,
    },
    {
      title: "Install AD Agent",
      content: <FirstContent />,
    },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  return (
    <Row className="content-conatiner">
      {isSetupADTour && startTour()}
      {setNotification}
      <Col span={20}>
        <Row justify="space-between">
          <Col>
            <h2 className="title">Integrate Active Directory</h2>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Steps current={current} items={items} />
          </Col>
        </Row>
        <Row>
          <Col span={24} id="addIdentityProviderForm">
            {steps[current].content}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ADStep;
